import { useEffect, useState } from "react";

// Gestisce un mini-tour di pagina: parte automaticamente una sola volta al primo accesso
// alla pagina (flag in localStorage) ed è sempre ri-attivabile con `open()`.
export function usePageTour(key, autoDelay = 700) {
  const [show, setShow] = useState(false);
  const storageKey = `tb_tour_page_${key}`;

  useEffect(() => {
    if (!localStorage.getItem(storageKey)) {
      const t = setTimeout(() => setShow(true), autoDelay);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [storageKey, autoDelay]);

  const open = () => setShow(true);
  const close = () => { localStorage.setItem(storageKey, "1"); setShow(false); };

  return { show, open, close };
}
